import "../../Spin.css";
import { jsx } from "react/jsx-runtime";
const base = "Spin_base_24d9f";
const spinner = "Spin_spinner_24d9f";
const rotateZ = "Spin_rotateZ_24d9f";
const spinner__bowtie = "Spin_spinner__bowtie_24d9f";
const rotateHalf = "Spin_rotateHalf_24d9f";
const spinner__half = "Spin_spinner__half_24d9f";
const spinner__shadow = "Spin_spinner__shadow_24d9f";
const rotateX = "Spin_rotateX_24d9f";
const rotateY = "Spin_rotateY_24d9f";
const css = {
  base,
  spinner,
  rotateZ,
  spinner__bowtie,
  rotateHalf,
  spinner__half,
  spinner__shadow,
  rotateX,
  rotateY
};
const Spin = ({ type }) => {
  const classnames = [css.spinner, css[`spinner__${type}`]];
  return /* @__PURE__ */ jsx("div", { className: css.base, children: /* @__PURE__ */ jsx("div", { className: classnames.join(" ") }) });
};
const SpinBowtie = () => /* @__PURE__ */ jsx(Spin, { type: "bowtie" });
const SpinHalf = () => /* @__PURE__ */ jsx(Spin, { type: "half" });
const SpinShadow = () => /* @__PURE__ */ jsx(Spin, { type: "shadow" });
export {
  SpinBowtie,
  SpinHalf,
  SpinShadow,
  Spin as default
};
